"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUnpacker = exports.createToObjectInstruction = exports.createToArrayInstruction = exports.createForeachInstruction = exports.createProcedureInstruction = exports.createGetValueInstruction = exports.toInstructionSchema = void 0;
var num_easy_log_1 = require("num-easy-log");
var ReferencesResolver_1 = require("./ReferencesResolver");
var Util_1 = require("./Util");
var resolver = ReferencesResolver_1.createReferencesResolver(true);
var toInstructionSchema = function (is) {
    if (Array.isArray(is)) {
        for (var _i = 0, is_1 = is; _i < is_1.length; _i++) {
            var i = is_1[_i];
            validateInstruction(i);
        }
        return is;
    }
    throw new Error('Invalid transformation object - should be an array of Instructions.');
};
exports.toInstructionSchema = toInstructionSchema;
var validateProcedureInstruction = function (is) {
    for (var _i = 0, is_2 = is; _i < is_2.length; _i++) {
        var i = is_2[_i];
        validateInstruction(i);
    }
};
var validateToObjectInstruction = function (i) {
    if (i.source === '') {
        throw new Error('Invalid source in : ' + JSON.stringify(i));
    }
    if (i.target === '') {
        throw new Error('Invalid target in : ' + JSON.stringify(i));
    }
    if (i.return && i.return === '') {
        throw new Error('Invalid return in : ' + JSON.stringify(i));
    }
    if (!i.keys || i.keys.length === 0) {
        throw new Error('No keys specified in : ' + JSON.stringify(i));
    }
    if (!i.values || i.values.length === 0) {
        throw new Error('No values specified in : ' + JSON.stringify(i));
    }
};
var validateToArrayInstruction = function (i) {
    if (i.source === '') {
        throw new Error('Invalid source in : ' + JSON.stringify(i));
    }
    if (i.target === '') {
        throw new Error('Invalid target in : ' + JSON.stringify(i));
    }
    if (i.return && i.return === '') {
        throw new Error('Invalid return in : ' + JSON.stringify(i));
    }
    if (!i.keys || i.keys.length === 0) {
        throw new Error('No keys specified in : ' + JSON.stringify(i));
    }
    if (!i.values || i.values.length === 0) {
        throw new Error('No values specified in : ' + JSON.stringify(i));
    }
};
var validateGetValueInstruction = function (i) {
    if (i.source === '') {
        throw new Error('Invalid source in : ' + JSON.stringify(i));
    }
    if (i.target === '') {
        throw new Error('Invalid target in : ' + JSON.stringify(i));
    }
    if (i.return && i.return === '') {
        throw new Error('Invalid return in : ' + JSON.stringify(i));
    }
    if (!i.key || i.key === '') {
        throw new Error('No key specified in : ' + JSON.stringify(i));
    }
};
var validateForeachInstruction = function (i) {
    if (i.source === '') {
        throw new Error('Invalid source in : ' + JSON.stringify(i));
    }
    if (i.target === '') {
        throw new Error('Invalid target in : ' + JSON.stringify(i));
    }
    if (i.loopVar && i.loopVar === '') {
        throw new Error('Invalid loopVar in : ' + JSON.stringify(i));
    }
    if (!i.instruction) {
        throw new Error('No instruction specified in : ' + JSON.stringify(i));
    }
};
var createGetValueInstruction = function (i) {
    return function (e) {
        if (i.action === 'getValue') {
            num_easy_log_1.log.debug('Calling "getValue" :' + i.comment);
            var source = findVariable(e.stack, i.source);
            if (!source) {
                num_easy_log_1.log.debug('Source not matched for : ' + i.source);
                return null;
            }
            var sourceValues = getSourceValue(i.key, source);
            var target = sourceValues.get(i.key);
            setTarget(e.stack, i.target, target);
            if (i.return) {
                return e.stack[e.stack.length - 1].locals[i.return];
            }
            else {
                e.stack[e.stack.length - 1].result = target;
                return target;
            }
        }
        else {
            num_easy_log_1.log.debug('Skipping "getValue" :' + i.comment);
            return null;
        }
    };
};
exports.createGetValueInstruction = createGetValueInstruction;
var createProcedureInstruction = function (i) {
    var program = function (e) { return e; };
    i.forEach(function (step) {
        var instr = exports.createUnpacker(step);
        program = chain(program, instr);
    });
    return program;
};
exports.createProcedureInstruction = createProcedureInstruction;
var chain = function (f, g) {
    return function (e) {
        f(e);
        g(e);
    };
};
var createForeachInstruction = function (i) {
    var instr = exports.createUnpacker(i.instruction);
    return function (e) {
        if (i.action === 'foreach') {
            num_easy_log_1.log.debug('Calling "foreach" :' + i.comment);
            var source = findVariable(e.stack, i.source);
            if (!source) {
                num_easy_log_1.log.debug('Source not matched for : ' + i.source);
            }
            if (Array.isArray(source)) {
                var target_1 = new Array();
                source.forEach(function (item) {
                    e.stack.push({ locals: {}, result: null });
                    e.stack[e.stack.length - 1].locals[i.loopVar] = item;
                    instr(e);
                    target_1.push(e.stack[e.stack.length - 1].result);
                    e.stack.pop();
                });
                setTarget(e.stack, i.target, target_1);
            }
        }
        else {
            num_easy_log_1.log.debug('Skipping "foreach" :' + i.comment);
        }
    };
};
exports.createForeachInstruction = createForeachInstruction;
var createToArrayInstruction = function (i) {
    return function (e) {
        if (i.action === 'toArray') {
            num_easy_log_1.log.debug('Calling "toArray" :' + i.comment);
            var source = findVariable(e.stack, i.source);
            if (!source) {
                num_easy_log_1.log.debug('Source not matched for : ' + i.source);
                return null;
            }
            var sourceValues = getSourceValues(i.keys, source);
            if (sourceValues.size > 0) {
                var target = new Array();
                for (var k in i.values) {
                    if (i.values.hasOwnProperty(k)) {
                        target.push(i.values[k]);
                    }
                }
                Util_1.indexObject('', sourceValues, source);
                var result = resolver.resolve(sourceValues, target);
                setTarget(e.stack, i.target, result);
                if (i.return) {
                    return e.stack[e.stack.length - 1].locals[i.return];
                }
                else {
                    e.stack[e.stack.length - 1].result = result;
                    return result;
                }
            }
        }
        num_easy_log_1.log.debug('Skipping "toArray" :' + i.comment);
        return null;
    };
};
exports.createToArrayInstruction = createToArrayInstruction;
var createToObjectInstruction = function (i) {
    return function (e) {
        if (i.action === 'toObject') {
            num_easy_log_1.log.debug('Calling "toObject" :' + i.comment);
            var source = findVariable(e.stack, i.source);
            if (!source) {
                num_easy_log_1.log.debug('Source not matched for : ' + i.source);
                return null;
            }
            var sourceValues = getSourceValues(i.keys, source);
            if (typeof source !== 'object' && i.keys.length > 0) {
                if (typeof source !== 'string' || !source.startsWith('%')) {
                    sourceValues.set(i.keys[0], source);
                }
            }
            if (sourceValues.size > 0) {
                var target = new Object();
                for (var k in i.values) {
                    if (i.values.hasOwnProperty(k)) {
                        target[k] = i.values[k];
                    }
                }
                Util_1.indexObject('', sourceValues, source);
                var result = resolver.resolve(sourceValues, target);
                setTarget(e.stack, i.target, result);
                if (i.return) {
                    return e.stack[e.stack.length - 1].locals[i.return];
                }
                else {
                    e.stack[e.stack.length - 1].result = result;
                    return result;
                }
            }
        }
        num_easy_log_1.log.debug('Skipping "toObject" :' + i.comment);
        return null;
    };
};
exports.createToObjectInstruction = createToObjectInstruction;
var setTarget = function (frames, s, result) {
    if (s.startsWith('/')) {
        var path = s.split('.');
        return followPathAndSet(frames[0].locals, path, result);
    }
    else {
        var path = s.split('.');
        var i = frames.length - 1;
        if (i >= 0) {
            return followPathAndSet(frames[i].locals, path, result);
        }
    }
};
var findVariable = function (frames, s) {
    if (s.startsWith('/')) {
        var path = s.split('.');
        return followPath(frames[0].locals, path);
    }
    else {
        var path = s.split('.');
        var i = frames.length - 1;
        while (i >= 0) {
            if (frames[i].locals[path[0]]) {
                return followPath(frames[i].locals, path);
            }
            i--;
        }
    }
    return undefined;
};
var followPath = function (data, path) {
    var result = data;
    for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
        var i = path_1[_i];
        result = result[i];
        if (!result) {
            return null;
        }
    }
    return result;
};
var followPathAndSet = function (data, path, value) {
    var result = data;
    for (var i = 0; i < path.length - 1; i++) {
        if (!result[path[i]]) {
            result[path[i]] = new Object();
        }
        result = result[path[i]];
    }
    result[path[path.length - 1]] = value;
};
var getSourceValues = function (keys, o) {
    var result = new Map();
    if (Array.isArray(o)) {
        for (var i = 0; i < keys.length; i++) {
            result.set(keys[i], o[i]);
        }
        return result;
    }
    if (typeof o === 'object') {
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var k = keys_1[_i];
            if (o[k]) {
                result.set(k, o[k]);
            }
        }
    }
    return result;
};
var getSourceValue = function (key, o) {
    var result = new Map();
    if (typeof o === 'object') {
        if (o[key]) {
            result.set(key, o[key]);
        }
    }
    return result;
};
var createUnpacker = function (i) {
    if (isToObjectInstruction(i)) {
        return exports.createToObjectInstruction(i);
    }
    else if (isForeachInstruction(i)) {
        return exports.createForeachInstruction(i);
    }
    else if (isProcedureInstruction(i)) {
        return exports.createProcedureInstruction(i);
    }
    else if (isGetValueInstruction(i)) {
        return exports.createGetValueInstruction(i);
    }
    else if (isToArrayInstruction(i)) {
        return exports.createToArrayInstruction(i);
    }
    return function (e) {
        num_easy_log_1.log.debug('Unknown Instruction: ' + JSON.stringify(i) + '\n' + JSON.stringify(e));
    };
};
exports.createUnpacker = createUnpacker;
var isToArrayInstruction = function (i) {
    return i.action === 'toArray';
};
var isGetValueInstruction = function (i) {
    return i.action === 'getValue';
};
var isForeachInstruction = function (i) {
    return i.action === 'foreach';
};
var isToObjectInstruction = function (i) {
    return i.action === 'toObject';
};
var isProcedureInstruction = function (i) {
    return Array.isArray(i);
};
var validateInstruction = function (i) {
    if (isToObjectInstruction(i)) {
        validateToObjectInstruction(i);
    }
    else if (isForeachInstruction(i)) {
        validateForeachInstruction(i);
    }
    else if (isProcedureInstruction(i)) {
        validateProcedureInstruction(i);
    }
    else if (isGetValueInstruction(i)) {
        validateGetValueInstruction(i);
    }
    else if (isToArrayInstruction(i)) {
        validateToArrayInstruction(i);
    }
    else {
        throw new Error('Invalid Instruction - ' + JSON.stringify(i));
    }
};
//# sourceMappingURL=instructions.js.map